import React, { useEffect } from "react";
import BaseGameActionButton from "../../../components/GameActionButtons";
import { useSwiper } from "swiper/react";
import "./style.scss";
import emitter, { SWIPER_ACTIONS } from "../../../utils/emitter";
export default function NextSlideBtn() {
  const swiper = useSwiper();

  const showNextSlide = () => {
    swiper.slideNext();
  };

  useEffect(() => {
    emitter.on(SWIPER_ACTIONS.SHOW_NEXT_SLIDE, (card) => {
      if (!card.selected) {
        swiper.slideNext(300);
      }
    });
    // emitter.off(SWIPER_ACTIONS.SHOW_NEXT_SLIDE, showNextSlide);
  }, []);

  return (
    <BaseGameActionButton
      className="next-slide-btn"
      onClick={showNextSlide}
      type="forward"
    />
  );
}
